<template>
  <div id="">
      <PageLoader />
      <NavBar />
      <HeaderBar />

        <!-- ============ TITLE START ============ -->
		<section id="title">
			<div class="container">
				<div class="row">
					<div class="col-sm-12 text-center">
						<h1>Options</h1>
						<h4>Some template elements</h4>
					</div>
				</div>
			</div>
		</section>

		<!-- ============ TITLE END ============ -->

        <!-- ============ OPTIONS START ============ -->
		<section id="options">
			<div class="container">

				<!-- Columns Start -->

				<div class="row">
					<div class="col-sm-12">
						<h2>12 Columns Grid</h2>
					</div>
				</div>
			
				<div class="row text-center">
					<div class="col-sm-12">
						<div class="column img-rounded">12</div>
					</div>
				</div>

				<div class="row text-center">
					<div class="col-sm-6">
						<div class="column img-rounded">6</div>
					</div>
					<div class="col-sm-6">
						<div class="column img-rounded">6</div>
					</div>
				</div>

				<div class="row text-center">
					<div class="col-sm-4">
						<div class="column img-rounded">4</div>
					</div>
					<div class="col-sm-4">
						<div class="column img-rounded">4</div>
					</div>
					<div class="col-sm-4">
						<div class="column img-rounded">4</div>
					</div>
				</div>
			
				<div class="row text-center">
					<div class="col-sm-3">
						<div class="column img-rounded">3</div>
					</div>
					<div class="col-sm-3">
						<div class="column img-rounded">3</div>
					</div>
					<div class="col-sm-3">
						<div class="column img-rounded">3</div>
					</div>
					<div class="col-sm-3">
						<div class="column img-rounded">3</div>
					</div>
				</div>
			
				<div class="row text-center">
					<div class="col-sm-2">
						<div class="column img-rounded">2</div>
					</div>
					<div class="col-sm-2">
						<div class="column img-rounded">2</div>
					</div>
					<div class="col-sm-2">
						<div class="column img-rounded">2</div>
					</div>
					<div class="col-sm-2">
						<div class="column img-rounded">2</div>
					</div>
					<div class="col-sm-2">
						<div class="column img-rounded">2</div>
					</div>
					<div class="col-sm-2">
						<div class="column img-rounded">2</div>
					</div>
				</div>
			
				<div class="row text-center">
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
					<div class="col-sm-1">
						<div class="column img-rounded">1</div>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12">
						<hr>
					</div>
				</div>

				<!-- Columns End -->

				<!-- Buttons Start -->

				<div class="row">

					<div class="col-sm-6">
						<h2>Single button dropdowns</h2>
						<div class="btn-group">
							<button type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Success <span class="caret"></span></button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
						<div class="btn-group">
							<button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Info <span class="caret"></span></button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
						<div class="btn-group">
							<button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Warning <span class="caret"></span></button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
						<div class="btn-group">
							<button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Danger <span class="caret"></span></button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
					</div>

					<div class="col-sm-6">
						<h2>Split button dropdowns</h2>
						<div class="btn-group">
							<button type="button" class="btn btn-success">Success</button>
							<button type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
								<span class="caret"></span>
								<span class="sr-only">Toggle Dropdown</span>
							</button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
						<div class="btn-group">
							<button type="button" class="btn btn-info">Info</button>
							<button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
								<span class="caret"></span>
								<span class="sr-only">Toggle Dropdown</span>
							</button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
						<div class="btn-group">
							<button type="button" class="btn btn-warning">Warning</button>
							<button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
								<span class="caret"></span>
								<span class="sr-only">Toggle Dropdown</span>
							</button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
						<div class="btn-group">
							<button type="button" class="btn btn-danger">Danger</button>
							<button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
								<span class="caret"></span>
								<span class="sr-only">Toggle Dropdown</span>
							</button>
							<ul class="dropdown-menu" role="menu">
								<li><a href="#">Action</a></li>
								<li><a href="#">Another action</a></li>
								<li><a href="#">Something else here</a></li>
								<li class="divider"></li>
								<li><a href="#">Separated link</a></li>
							</ul>
						</div>
					</div>

				</div>

				<div class="row">
					<div class="col-sm-12">
						<hr>
					</div>
				</div>

				<!-- Buttons END -->

				<!-- Navs Start -->

				<div class="row">

					<div class="col-sm-6">
						<h2>Tabs</h2>

						<div role="tabpanel">

							<!-- Nav tabs -->
							<ul class="nav nav-tabs" role="tablist">
								<li role="presentation" class="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab">Home</a></li>
								<li role="presentation"><a href="#profile" aria-controls="profile" role="tab" data-toggle="tab">Profile</a></li>
								<li role="presentation"><a href="#messages" aria-controls="messages" role="tab" data-toggle="tab">Messages</a></li>
							</ul>

							<!-- Tab panes -->
							<div class="tab-content">
								<div role="tabpanel" class="tab-pane active" id="home">
									<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sit amet tristique nisl. Praesent et aliquam odio, sed semper ante. Mauris placerat turpis ac quam commodo, id interdum mauris auctor.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="profile">
									<p>Donec sodales nunc libero, placerat finibus felis suscipit a. Vestibulum dignissim augue non urna porta posuere. Nam aliquet augue nec orci porttitor posuere. Nunc egestas pulvinar est bibendum hendrerit.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="messages">
									<p>Nulla tempor non quam eget semper. Mauris ut purus ut lectus pharetra laoreet. Sed vulputate turpis quis mauris ultricies elementum. Donec quis ullamcorper neque.</p>
								</div>
							</div>

						</div>

						<p>&nbsp;</p>

						<div role="tabpanel">

							<!-- Nav tabs -->
							<ul class="nav nav-tabs nav-justified" role="tablist">
								<li role="presentation" class="active"><a href="#we" aria-controls="we" role="tab" data-toggle="tab">We</a></li>
								<li role="presentation"><a href="#you" aria-controls="you" role="tab" data-toggle="tab">You</a></li>
								<li role="presentation"><a href="#them" aria-controls="them" role="tab" data-toggle="tab">Them</a></li>
							</ul>

							<!-- Tab panes -->
							<div class="tab-content">
								<div role="tabpanel" class="tab-pane active" id="we">
									<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sit amet tristique nisl. Praesent et aliquam odio, sed semper ante. Mauris placerat turpis ac quam commodo, id interdum mauris auctor.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="you">
									<p>Donec sodales nunc libero, placerat finibus felis suscipit a. Vestibulum dignissim augue non urna porta posuere. Nam aliquet augue nec orci porttitor posuere. Nunc egestas pulvinar est bibendum hendrerit.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="them">
									<p>Nulla tempor non quam eget semper. Mauris ut purus ut lectus pharetra laoreet. Sed vulputate turpis quis mauris ultricies elementum. Donec quis ullamcorper neque.</p>
								</div>
							</div>

						</div>

					</div>

					<div class="col-sm-6">
						<h2>Pills</h2>

						<div role="tabpanel">

							<!-- Nav pills -->
							<ul class="nav nav-pills">
								<li role="presentation" class="active"><a href="#about" aria-controls="about" role="tab" data-toggle="tab">About</a></li>
								<li role="presentation"><a href="#services" aria-controls="services" role="tab" data-toggle="tab">Services</a></li>
								<li role="presentation"><a href="#sales" aria-controls="sales" role="tab" data-toggle="tab">Sales</a></li>
							</ul>

							<!-- Tab panes -->
							<div class="tab-content">
								<div role="tabpanel" class="tab-pane active" id="about">
									<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sit amet tristique nisl. Praesent et aliquam odio, sed semper ante. Mauris placerat turpis ac quam commodo, id interdum mauris auctor.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="services">
									<p>Donec sodales nunc libero, placerat finibus felis suscipit a. Vestibulum dignissim augue non urna porta posuere. Nam aliquet augue nec orci porttitor posuere. Nunc egestas pulvinar est bibendum hendrerit.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="sales">
									<p>Nulla tempor non quam eget semper. Mauris ut purus ut lectus pharetra laoreet. Sed vulputate turpis quis mauris ultricies elementum. Donec quis ullamcorper neque.</p>
								</div>
							</div>

						</div>

						<p>&nbsp;</p>

						<div role="tabpanel">

							<!-- Nav pills -->
							<ul class="nav nav-pills nav-justified">
								<li role="presentation" class="active"><a href="#work" aria-controls="work" role="tab" data-toggle="tab">Work</a></li>
								<li role="presentation"><a href="#fun" aria-controls="fun" role="tab" data-toggle="tab">Fun</a></li>
								<li role="presentation"><a href="#life" aria-controls="life" role="tab" data-toggle="tab">Life</a></li>
							</ul>

							<!-- Tab panes -->
							<div class="tab-content">
								<div role="tabpanel" class="tab-pane active" id="work">
									<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sit amet tristique nisl. Praesent et aliquam odio, sed semper ante. Mauris placerat turpis ac quam commodo, id interdum mauris auctor.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="fun">
									<p>Donec sodales nunc libero, placerat finibus felis suscipit a. Vestibulum dignissim augue non urna porta posuere. Nam aliquet augue nec orci porttitor posuere. Nunc egestas pulvinar est bibendum hendrerit.</p>
								</div>
								<div role="tabpanel" class="tab-pane" id="life">
									<p>Nulla tempor non quam eget semper. Mauris ut purus ut lectus pharetra laoreet. Sed vulputate turpis quis mauris ultricies elementum. Donec quis ullamcorper neque.</p>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12">
						<hr>
					</div>
				</div>

				<!-- Navs End -->

				<!-- Alerts -->

				<div class="row">

					<div class="col-sm-6">
						<h2>Alerts</h2>
						<div class="alert alert-success" role="alert">
							<strong>Well done!</strong> You successfully read this important alert message.
						</div>
						<div class="alert alert-info" role="alert">
							<strong>Heads up!</strong> This alert needs your attention, but it's not super important.
						</div>
						<div class="alert alert-warning" role="alert">
							<strong>Warning!</strong> Better check yourself, you're not looking too good.
						</div>
						<div class="alert alert-danger" role="alert">
							<strong>Oh snap!</strong> Change a few things up and try submitting again.
						</div>
					</div>

					<div class="col-sm-6">
						<h2>Accordion</h2>
						<div class="panel-group" id="accordion">
							<div class="panel panel-default">
								<div class="panel-heading">
									<h4 class="panel-title">
										<a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
											Collapsible Group Item #1
											<i class="indicator glyphicon glyphicon-chevron-up pull-right"></i>
										</a>
									</h4>
								</div>
								<div id="collapseOne" class="panel-collapse collapse in">
									<div class="panel-body">
										Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
									</div>
								</div>
							</div>
							<div class="panel panel-default">
								<div class="panel-heading">
									<h4 class="panel-title">
										<a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
											Collapsible Group Item #2
											<i class="indicator glyphicon glyphicon-chevron-down pull-right"></i>
										</a>
									</h4>
								</div>
								<div id="collapseTwo" class="panel-collapse collapse">
									<div class="panel-body">
										Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
									</div>
								</div>
							</div>
							<div class="panel panel-default">
								<div class="panel-heading">
									<h4 class="panel-title">
										<a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
											Collapsible Group Item #3
											<i class="indicator glyphicon glyphicon-chevron-down pull-right"></i>
										</a>
									</h4>
								</div>
								<div id="collapseThree" class="panel-collapse collapse">
									<div class="panel-body">
										Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

				<div class="row">
					<div class="col-sm-12">
						<hr>
					</div>
				</div>

				<!-- Alerts -->

				<!-- Progress Bars Start -->

				<div class="row">
					<div class="col-sm-12">
						<h2>Progress Bars</h2>
					</div>
				</div>

				<div class="row">

					<div class="col-sm-4">
						<div class="progress">
							<div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
								40%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">
								20%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
								60%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">
								80%
							</div>
						</div>
					</div>

					<div class="col-sm-4">
						<div class="progress">
							<div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
								40%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">
								20%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
								60%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">
								80%
							</div>
						</div>
					</div>

					<div class="col-sm-4">
						<div class="progress">
							<div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
								40%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">
								20%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
								60%
							</div>
						</div>
						<div class="progress">
							<div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">
								80%
							</div>
						</div>
					</div>

				</div>

				<!-- Progress Bars End -->

			</div>
		</section>

		<!-- ============ OPTIONS END ============ -->

      <ContactsWrapper />      
      <FooterWrapper />
      <LoginPopup />
      <RegisterPopup />
  </div>
</template>

<script>
import PageLoader from '@/components/PageLoader.vue'
import NavBar from '@/components/NavBar.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import ContactsWrapper from '@/components/ContactsWrapper.vue'
import FooterWrapper from '@/components/FooterWrapper.vue'
import LoginPopup from '@/components/LoginPopup.vue'
import RegisterPopup from "@/components/RegisterPopup.vue"
export default {
    components:{
        PageLoader,
        NavBar,
        HeaderBar,
        ContactsWrapper,        
        FooterWrapper,
        LoginPopup,
        RegisterPopup
    },
	created(){
	let ckeditor = document.createElement('script');  
    ckeditor.setAttribute('src',"js/settings.js");
    document.head.appendChild(ckeditor);
  }
}
</script>

<style>

</style>